import { gistActionTypes } from '../_constants';

export function gists(state = {}, action) {
  switch (action.type) {

    // get gist request
    case gistActionTypes.GET_GIST_REQUEST:
      return {
        ...state,
        currentGist: {
          loading: true
        }
      };

    // get gist success
    case gistActionTypes.GET_GIST_SUCCESS:
      return {
        ...state,
        currentGist: {
          loaded: true,
          gist: action.gist
        }
      };

    // get gist failure
    case gistActionTypes.GET_GIST_FAILURE:
      return {
        ...state,
        currentGist: false
      };

    case gistActionTypes.UNSET_CURRENT_GIST:
      return {
        ...state,
        currentGist: false
      }

    default:
      return state
  }
}